/** @jsxImportSource @emotion/react */
import Typography from '@mui/material/Typography';
import { useStyles } from './component.styles';

function Footer() {
  const classes = useStyles();

  return (
    <>
      <div css={classes.container}>
        <Typography variant="body2" component="p" align="center" paragraph>
          Copyright &copy; Omnigen Biodata {new Date().getFullYear()}
        </Typography>
      </div>
    </>
  );
}

export default Footer;
